'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var modal = require('./modal.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = modal["default"].parts;

/**
 * Since the `maxWidth` prop references theme.sizes internally,
 * we can leverage that to size our modals.
 */
function getSize(value) {
  if (value === 'full') {
    return {
      dialog: {
        maxW: '100vw',
        h: '100vh'
      }
    };
  }
  return {
    dialog: {
      maxW: value
    }
  };
}
var baseStyleOverlay = {
  bg: 'blackAlpha.600',
  zIndex: 'overlay'
};
var baseStyleDialogContainer = {
  display: 'flex',
  zIndex: 'modal',
  justifyContent: 'center'
};
function baseStyleDialog(props) {
  var isFullHeight = props.isFullHeight;
  return _objectSpread(_objectSpread({}, isFullHeight && {
    height: '100vh'
  }), {}, {
    zIndex: 'modal',
    maxH: '100vh',
    bg: 'white',
    boxShadow: 'lg'
  });
}
var baseStyleHeader = {
  px: 6,
  py: 4,
  fontSize: '2xl',
  textStyle: 'heading'
};
var baseStyleCloseButton = {
  position: 'absolute',
  top: 5,
  insetEnd: 4,
  fontSize: 'lg'
};
var baseStyleBody = {
  px: 6,
  py: 2,
  flex: 1,
  overflow: 'auto'
};
var baseStyleFooter = {
  px: 6,
  py: 4
};
var baseStyle = function baseStyle(props) {
  return {
    overlay: baseStyleOverlay,
    dialogContainer: baseStyleDialogContainer,
    dialog: baseStyleDialog(props),
    header: baseStyleHeader,
    closeButton: baseStyleCloseButton,
    body: baseStyleBody,
    footer: baseStyleFooter
  };
};
var sizes = {
  xs: getSize('xs'),
  sm: getSize('md'),
  md: getSize('lg'),
  lg: getSize('2xl'),
  xl: getSize('4xl'),
  full: getSize('full')
};
var defaultProps = {
  size: 'xs'
};
var Drawer = {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
exports["default"] = Drawer;